<div class="panel park-state">
  <div class="panel-header">
    <h2>Etat du parc</h2>
    <div class="panel-tools">
      <button
        class="round-tool mobile-list-toggle"
        type="button"
        [attr.aria-label]="
          listeVisibleMobile() ? 'Masquer les installations' : 'Afficher les installations'
        "
        [attr.aria-expanded]="listeVisibleMobile()"
        (click)="listeVisibleMobile.set(!listeVisibleMobile())"
      >
        <span class="material-symbols-outlined">format_list_bulleted</span>
      </button>
    </div>
  </div>

  <div class="legend-pills">
    <span
      class="legend-pill"
      [class.selected]="filtresActifs().has(etatservice.NIVEAU_ARRET)"
      (click)="filtreEtatListeInstallations(etatservice.NIVEAU_ARRET)"
      ><i class="dot dot-red"></i>À l'arrêt</span
    >
    <span
      class="legend-pill"
      [class.selected]="filtresActifs().has(etatservice.NIVEAU_HORSLIGNE)"
      (click)="filtreEtatListeInstallations(etatservice.NIVEAU_HORSLIGNE)"
      ><i class="dot dot-black"></i>Hors ligne</span
    >
    <span
      class="legend-pill"
      [class.selected]="filtresActifs().has(etatservice.NIVEAU_PERTE)"
      (click)="filtreEtatListeInstallations(etatservice.NIVEAU_PERTE)"
      ><i class="dot dot-amber"></i>Avec perte</span
    >
    <span
      class="legend-pill"
      [class.selected]="filtresActifs().has(etatservice.NIVEAU_SANS_PERTE)"
      (click)="filtreEtatListeInstallations(etatservice.NIVEAU_SANS_PERTE)"
      ><i class="dot dot-violet"></i>Sans perte</span
    >
    <span
      class="legend-pill"
      [class.selected]="filtresActifs().has(etatservice.NIVEAU_NORMAL)"
      (click)="filtreEtatListeInstallations(etatservice.NIVEAU_NORMAL)"
      ><i class="dot dot-green"></i>Normal</span
    >
  </div>

  <div class="donut-wrap">
    <div
      class="donut-chart"
      [style.background]="donutStyle()"
      (mouseleave)="hoveredSegment.set(null)"
    >
      <div class="donut-center">
        @if (hoveredSegment(); as seg) {
          <strong>{{ seg.count }}</strong>
          <span>{{ seg.label }}</span>
        } @else {
          <strong>{{ installationsFiltrees().length }}</strong>
          <span>centrales</span>
        }
      </div>
      <svg class="donut-overlay" viewBox="0 0 100 100">
        @for (seg of donutSegments(); track seg.niveau) {
          <path
            [attr.d]="seg.path"
            fill="transparent"
            (mouseenter)="hoveredSegment.set({ label: seg.label, count: seg.count })"
          />
        }
      </svg>
    </div>
  </div>

  <div class="park-installations-list" [class.is-open]="listeVisibleMobile()">
    <div class="panel-tools installation-tools">
      <button
        class="round-tool"
        type="button"
        aria-label="Rechercher une installation"
        [attr.aria-expanded]="filtreVisible()"
        (click)="filtreVisible.set(!filtreVisible())"
      >
        <span class="material-symbols-outlined" aria-hidden="true">search</span>
      </button>
      <button class="round-tool" type="button" aria-label="Vue carte/liste" (click)="toggleVue()">
        <span class="material-symbols-outlined" aria-hidden="true">{{
          vueCarte() ? 'format_list_bulleted' : 'view_agenda'
        }}</span>
      </button>
    </div>
    @if (filtreVisible()) {
      <div class="searchbox installation-search">
        <i class="search-icon" aria-hidden="true"></i>
        <input
          #champRecherche
          type="search"
          aria-label="Rechercher une installation"
          placeholder="Rechercher une installation..."
          [value]="recherche()"
          (input)="recherche.set(champRecherche.value)"
        />
      </div>
    }

    <div class="site-list">
      @for (installation of installationsFiltrees(); track installation.id) {
        @if (vueCarte()) {
          <a
            class="site-card site-card-link"
            [routerLink]="['/installation', installation.id]"
            [attr.aria-label]="'Voir ' + installation.nom"
          >
            <div class="site-card-top">
              <div>
                <h3>{{ installation.nom }}</h3>
                <span class="status-chip" [class]="'status-chip ' + statusClass(installation.etat)">
                  {{ statusLabel(installation.etat) }}
                </span>
              </div>
              <span class="site-card-arrow" aria-hidden="true">&rsaquo;</span>
            </div>
            <app-quick-metrics-grid
              [items]="quickMetricsForInstallation(installation)"
              [avecContour]="false"
            />
          </a>
        } @else {
          <a
            class="site-card site-card-link site-card-compact"
            [routerLink]="['/installation', installation.id]"
            [attr.aria-label]="'Voir ' + installation.nom + ' — ' + statusLabel(installation.etat)"
          >
            <i [class]="'dot dot-' + installation.etat?.niveau" aria-hidden="true"></i>
            <h3>{{ installation.nom }}</h3>
            <span class="site-card-arrow" aria-hidden="true">&rsaquo;</span>
          </a>
        }
      }
    </div>
  </div>
</div>
